<template>
  <!-- Quotation(V)小额补款 - 单项 -->
  <div class="packageWrap">
    <el-table :data="tableData" class="wdb100" :header-cell-style="{ background: '#fdf6ec !important' }" :row-style="{ background: '#fdf6ec' }">
      <el-table-column prop="adjustmentNo" label="Quotation (V) No." align="center" width="110px" />
      <el-table-column prop="applymentNo" label="Linked Transaction No." align="center" width="140px" />
      <el-table-column prop="billingParty" label="Billing Party" align="center" />
      <el-table-column label="Service Charge" align="center">
        <template slot-scope="scope">
          <p class="fs18 fwb orange">{{ currencyAndAmountFormat(detail.billingCurrency, scope.row.serviceChargeTotal) }}</p>
        </template>
      </el-table-column>
      <el-table-column label="Third Party Fee" align="center">
        <template slot-scope="scope">
          <p class="fs18 fwb orange">{{ currencyAndAmountFormat(detail.billingCurrency, scope.row.thirdPartyFeeTotal) }}</p>
        </template>
      </el-table-column>
      <el-table-column label="Other Fee" align="center">
        <template slot-scope="scope">
          <p class="fs18 fwb orange">{{ currencyAndAmountFormat(detail.billingCurrency, scope.row.otherFeeTotal) }}</p>
        </template>
      </el-table-column>
      <el-table-column label="Attachments" align="center">
        <template slot-scope="scope">
          <p v-for="item in scope.row.attachmentUrls" :key="item.url">
            <a :href="item.url" target="_target">{{ item.name }}</a>
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" align="center" label="Create Time" width="120px" />
      <el-table-column prop="status" align="center" label="Status" width="110px">
        <template slot-scope="scope">
          <p>{{ adjustmentStatusFormat(scope.row.status) }}</p>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { isNumberLike } from "@/utils";
import { addition } from "@/utils/count";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  props: {
    detail: {
      type: Object,
      default: () => ({
        adjustment: {},
        billingCurrency: "",
        taxAmount: "",
        taxRate: "",
      }),
    },
  },
  data() {
    return {};
  },
  computed: {
    tableData() {
      if (!this.detail) return [];
      // 初始化三类费用的总和
      let serviceCharge = 0; // category: 1
      let thirdPartyFee = 0; // category: 2
      let otherFee = 0; // category: 3
      // 遍历 itemList 进行分类累加
      const adjustment = this.detail?.adjustment || {};
      adjustment?.itemList?.forEach(item => {
        const amount = isNumberLike(item.billingAmount) ? item.billingAmount : 0;
        if (item.category === 1) {
          serviceCharge = addition(serviceCharge, amount);
        } else if (item.category === 2) {
          thirdPartyFee = addition(thirdPartyFee, amount);
        } else if (item.category === 3) {
          otherFee = addition(otherFee, amount);
        }
      });

      return [
        {
          ...adjustment,
          serviceChargeTotal: serviceCharge,
          thirdPartyFeeTotal: thirdPartyFee,
          otherFeeTotal: otherFee,
        },
      ];
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.packageWrap {
  width: 100%;
  background-color: #fdf6ec;

  ::v-deep {
    .el-table {
      tr:hover {
        background: #fdf6ec !important;
      }

      .el-table__body tr:hover > td {
        background-color: #fdf6ec !important;
      }
    }
  }
}
</style>
